<template>
  <div id="prediction-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="220"
        :is-append-query="true"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--查看-->
          <el-button type="success" no="look" @click="lookHandler()">{{ $t('common.btn.look') }}</el-button>
          <!--新增-->
          <el-button type="primary" no="new" @click="addHandler()">{{ $t('common.btn.new') }}</el-button>
          <!--编辑-->
          <el-button :disabled="!editBtnEnabled" type="success" no="edit" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
          <!--复制-->
          <el-button type="primary" no="clone" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
          <!--删除-->
          <el-button :disabled="!deleteBtnEnabled" type="danger" no="delete" @click="deleteHandler()">{{ $t('SeaExport.Delete') }}</el-button>
          <template v-if="forecastApproval">
            <!--提交-->
            <el-button v-show="$checkPermission(['button_SIPREALERT_submit'])" type="primary" no="submit" @click="submitHanlder">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
            <!--撤回-->
            <el-button v-show="$checkPermission(['button_SIPREALERT_revoke'])" type="primary" no="withdraw" @click="revokeHanlder">{{ $t('Message.Withdraw') }}</el-button>
          </template>
          <!--协作状态: 审核通过-->
          <el-button v-show="$checkPermission(['button_SIPREALERT_accept']) && useOrderCenterMode && approveCooperationBusiness" type="primary" no="passAudit" @click="acceptHandler(0)">{{ $t('SeaExport.PassAudit') }}</el-button>
          <!--协作状态: 拒绝-->
          <el-button v-show="$checkPermission(['button_SIPREALERT_reject']) && useOrderCenterMode && approveCooperationBusiness" type="primary" no="approveRefuse" @click="rejectHandler(0)">{{ $t('SeaExport.Refuse') }}</el-button>
          <!--转正式业务-->
          <el-button v-show="$checkPermission(['button_SIPREALERT_siReportTransfer'])" type="primary" no="regularBusiness" @click="convertToRealJobHandler()">{{ $t('SeaExport.RegularBusiness') }}</el-button>
          <!--拒绝-->
          <el-button v-show="false" type="primary" no="refuse" @click="rejectHandler()">{{ $t('SeaExport.Refuse') }}</el-button>
        </div>
        <div slot="other">
          <div style="height: 12px;line-height: 12px;color: blue">{{ $t('queryJob.OrangeWorkingDaysFromETA') }}</div>
          <div style="height: 12px;line-height: 12px;color: blue">{{ $t('queryJob.RedWorkingDaysFromETA') }}</div>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="220000"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          style="width: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery && filter.total>0"
          config-module="220000"
          :total="filter.total"
          :page-count="filter.pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQueryByPage"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="filter.total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!--拒绝-->
    <reject-dialog
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { DocumentManage, stopBubble, getConfigBoolValue, sleep } from '@/utils/commonUtil'
import jobDetailIcon from '@/assets/job-detail.png'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { findSeaImportPerNoJob, advancedQuery, findPredictTwoWorkJob, preVerifyReject } from '@/api/SeaImport/seaImportJob'
import { batchUpdatePreVerifyState } from '@/api/booking/job'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import DateUtils from '@/utils/dateUtils'
import { isNumber } from '@/utils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import rejectDialog from '@/views/cargo/v0/SeaImport/components/Prediction/opVerifyFrameRejectDialog'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'

export default {
  name: 'PredictionGrid',
  components: {
    cargoAgGridWrapper,
    rejectDialog,
    CargoAdvanceSelect,
    searchItem,
    cargoTemplateSelectorDialog,
    cooperationVerifyDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    useOrderCenterMode: { type: Boolean, default: false },
    orderCenterBranch: { type: Boolean, default: false },
    approveCooperationBusiness: { type: Boolean, default: false }
  },
  data() {
    return {
      notRefresh: false,
      selectTypeNames: TYPE_NAMES,
      forecastApproval: false, // 是否用预报审批流程
      customSearchItems: [],
      appendQuery: false, // 追加查询
      isAdvancedQuery: false, // 是否为高级查询
      isEditing: false,
      filter: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        pageCount: 0,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      selectedJob: null,
      selectedDataList: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          this.lookHandler(event.data)
        },
        defaultColDef: {
          resizable: true
        },
        // onSortChanged: (event) => {
        //   // this.$logger.log('onSortChanged-event', event)
        //   if (this.rowDataBeforeSort.length !== this.rowData.length) {
        //     this.rowDataBeforeSort = this.rowData
        //   }
        //   if (!event.api.getSortModel().length) {
        //     this.rowData = this.rowDataBeforeSort
        //     this.rowDataBeforeSort = []
        //   } else {
        //     this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
        //   }
        // },
        context: {
          componentParent: this
        },
        getRowStyle: (params) => {
          if (!params.data) {
            return {}
          }
          const row = params.data
          if (row) {
            const colorType = Number(this.$store.state.settings.colorType) === 1
            if (colorType) {
              return JobUtils.financeColor(row)
            } else {
              const eta = row.eta
              let days = DateUtils.getBetweenDays(eta, DateUtils.formatStandardDate(new Date()))
              if (isNumber(days)) {
                days = Math.abs(Number(days)) // 取绝对值
                if (days > 3 && days <= 7) {
                  return { 'background': 'orange' }
                }
                if (days <= 3) {
                  return { 'background': 'red' }
                }
              }
            }
          }
          return {}
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected
      },
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage(),
      rejectWindow: { // 拒绝弹窗
        visible: false,
        jobNo: '',
        rejectCallBack: null
      },
      templateSelectorDialog: { // 打印弹窗
        visible: false,
        ctx: new SeaImportJob(),
        category: '',
        data: {}
      },
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      isQueryTwoWorkJob: true, // 查询最近两个工作日编辑过的单子
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        jobUuids: [],
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      }
    }
  },
  computed: {
    columnDefs() {
      const result = [
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          field: 'trustFromJob',
          colId: 'trustFromJob',
          enableRowGroup: true,
          width: 200
        },
        {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          field: 'relatedJob',
          colId: 'relatedJob',
          enableRowGroup: true,
          width: 200
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          colId: 'customerId',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          width: 200
        },
        {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          colId: 'hbl',
          enableRowGroup: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Mbl2'),
          field: 'mbl',
          colId: 'mbl',
          enableRowGroup: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PortOfLoadingAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          width: 200
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          },
          width: 200
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return params.data.carrierId ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.data.carrierId), 'auto_5') : ''
            }
            return ''
          },
          width: 200
        },
        {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          enableRowGroup: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          enableRowGroup: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PortOfLoading'),
          field: 'loadingPortCode',
          colId: 'loadingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          field: 'dischargingPortCode',
          colId: 'dischargingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityContract',
          colId: 'quantityContract',
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightContract',
          colId: 'weightContract',
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageContract',
          colId: 'cubageContract',
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('SeaExport.BusinessType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          enableRowGroup: true,
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.containerTypeLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessStatus'),
          field: 'jobState',
          colId: 'jobState',
          enableRowGroup: true,
          width: 180,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.getJobState(params.data)
            }
            return ''
          },
          filter: false,
          filterParams: {}
        },
        { headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          enableRowGroup: true,
          width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value, 3)
          }
        },
        { headerName: this.$t('SeaExport.DateOfArrival'),
          field: 'eta',
          colId: 'eta',
          enableRowGroup: true,
          width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          colId: 'dateCreated',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          enableRowGroup: true,
          width: 150,
          cellRenderer: params => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
          }
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          enableRowGroup: true,
          width: 150,
          cellRenderer: params => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          }
        },
        {
          headerName: this.$t('SeaExport.AirlinePerson2'),
          colId: 'planner',
          field: 'planner',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 80
        },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          colId: 'dc',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Creator'),
          field: 'createdBy',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.createdBy), 'chineseName')
            }
            return ''
          },
          width: 120
        },
        { headerName: this.$t('queryJob.totalIncome'), colId: 'income', field: 'income', width: 180,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('queryJob.totalCost'), colId: 'cost', field: 'cost', width: 180,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('FinanceManage.charge_profitAll'), colId: 'realProfit', field: 'realProfit', width: 180,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateStatus'),
          colId: 'cooperateStatus',
          field: 'cooperateStatus',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.cooperateStatusLabelFunc(Number(params.value))
          },
          hide: !this.useOrderCenterMode,
          width: 100, minWidth: 100
        }, {
          headerName: this.$t('Message.TerminalCompany'),
          colId: 'terminalCompany',
          field: 'terminalCompany',
          width: 200,
          enableRowGroup: true,
          hide: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.data.terminalCompany), 'chineseName')
            }
            return ''
          }
        }, {
          headerName: this.$t('Message.DeliveryAddress'),
          colId: 'deliveryAddress',
          field: 'deliveryAddress',
          width: 200,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: 'csrDepartment',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: 'dcDepartment',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          colId: 'plannerDepartment',
          field: 'plannerDepartment',
          width: 140,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
          field: 'cargoChineseName',
          width: 120,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
          field: 'cargoEnglishName',
          width: 120,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }
      ]
      if (this.forecastApproval) {
        result.push({
          headerName: this.$t('SeaExport.PreverifyStatus'),
          field: 'preverifyState',
          colId: 'preverifyState',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.getPreverifyStateCN(Number(params.data.preverifyState) || 1)
            }
            return ''
          },
          width: 150
        })
        result.push({
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'bookingRefuseNote',
          field: 'bookingRefuseNote',
          enableRowGroup: true,
          width: 150,
          valueGetter: (params) => {
            if (params.data && params.data.preverifyState === 3 || params.data.preverifyState === 6) {
              return params.data.bookingRefuseNote
            }
            return ''
          }
        })
      }
      return result
    },
    editBtnEnabled() {
      if (this.selectedJob && this.isCooperate(this.selectedJob.cooperateStatus)) return true
      if (this.forecastApproval) {
        return this.selectedJob && (this.selectedJob.preverifyState === 3 || this.selectedJob.preverifyState === 4 || this.selectedJob.preverifyState === 6)
      }
      return true
    },
    deleteBtnEnabled() {
      if (this.selectedJob && this.isCooperate(this.selectedJob.cooperateStatus)) return true
      if (this.forecastApproval) {
        if (this.selectedDataList && this.selectedDataList.length > 1) { // 批量删除
          return true
        } else {
          return this.selectedJob && (this.selectedJob.preverifyState === 3 || this.selectedJob.preverifyState === 6 || this.selectedJob.preverifyState === 4)
        }
      }
      return true
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.$store.state.tagsView.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await sleep(1000)
        this.forecastApproval = await getConfigBoolValue('ForecastApprovalSI')
        if (this.forecastApproval) {
          const searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'job.PREVERIFY_STATE'
          searchField.itemLabel = 'SeaExport.PreverifyStatus'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dataCacheKey = 'local_cache_SystemConstants$VERIFY_STATES'
          searchField.dataCacheKey = ''
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = SystemConstants.REMOTE_BOOKING_STATES
          this.customSearchItems = [searchField.formatObj2Json()]
        } else {
          this.customSearchItems = []
        }
        if (this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
          // 协作状态
          const searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 1
          searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
          searchField.itemName = 'cooperate.COOPERATE_STATUS'
          searchField.itemLabel = 'CargoMsg.Cargo_CooperateStatus'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = Array.from(SystemConstants.COOPERATE_STATUS)
          this.customSearchItems.push(searchField.formatObj2Json())
        }
        // 委托单位
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': '',
          'tagValue': 'cmpIdx',
          'useSales': true
        }
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.itemName = 'job.CUSTOMER_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
        searchField.defaultSelected = 1
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())
      }
    }
  },
  created() {
    this.initTwoWorkJob()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      this.selectedDataList = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeJob = node.data
            if (nodeJob.jobUuid) {
              this.selectedJob = nodeJob
              this.selectedDataList = this.gridApi.getSelectedRows()
            }
          }
        })
      }
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.jobUuid) this.selectedJob = node
    },
    // 查询最近几周编辑过的单子
    async initTwoWorkJob() {
      this.filter.pageNum = 1
      this.isQueryTwoWorkJob = true
      await cache.load(cacheName.CONFIG)
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      this.toQueryTwoWorkJob()
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        if (this.isQueryTwoWorkJob) {
          this.toQueryTwoWorkJob()
        } else {
          this.toSimpleQuery()
        }
      }
    },
    // 查询
    toQuery() {
      this.isQueryTwoWorkJob = false
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询最近两个工作日编辑过的单子
    toQueryTwoWorkJob() {
      this.filter.conditions = []
      this.filter.snapshotConditions = []
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      findPredictTwoWorkJob(this.filter).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
      })
    },
    // 高级查询
    toAdvancedQuery(conditions) {
      this.filter.conditions = []
      if (typeof conditions !== 'undefined') {
        this.filter.snapshotConditions = [... conditions] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [... conditions]
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(this.filter.conditions)
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', this.filter.conditions)) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filter.conditions.push(option.formatObj2Json())
      }
      // 预审状态
      const option = AdvancedSearchOption.removeOption('job.PREVERIFY_STATE', this.filter.conditions)
      if (option) {
        if (option.value instanceof Array && option.value.includes(1)) {
          option.value.push(0)
        }
        this.filter.conditions.push(option)
      }
      // 操作分公司
      const officeId = this.$store.getters.currentOfficeId
      this.filter.conditions.push(new AdvancedSearchOption(null, 'job.OP_OFFICE', officeId, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      this.filter.branchId = officeId
      this.filter.appendQuery = this.appendQuery
      this.filter.requires = ['siBookingVerify']
      this.filter.verifyModel = true
      this.loading = getLoading()
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(this.filter).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.notRefresh = false
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      findSeaImportPerNoJob(this.filter).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
      })
    },
    // 处理结果集
    handleQueryData(res) {
      this.loading.close()
      let results = res.data.list
      if (this.appendQuery) { // 追加查询数据去重
        results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        this.filter.total = results.length
      } else {
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.pageCount = res.data.pages
        this.filter.total = Number(res.data.total)
      }
      this.rowData = results
      this.selectedJob = null
      this.gridApi.clearFocusedCell()
    },
    // 查看
    lookHandler(row) {
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        const rows = row ? [row] : this.readSelectedRows()
        const jumpRows = []
        const openSet = new Set([...this.viewJobNoSet])
        for (const item of rows) {
          if (!openSet.has(item.jobNo)) {
            jumpRows.push(item)
            openSet.add(item.jobNo)
          }
        }
        if (openSet.size > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        if (jumpRows.length === 0) {
          this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: rows[0].jobNo }})
          return
        }
        for (const item of jumpRows) {
          setTimeout(() => {
            this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: item.jobNo }, params: { rowData: [...this.rowData] }})
          }, 100)
        }
        // 切回到跳转的第一票
        setTimeout(() => {
          this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: jumpRows[0].jobNo }})
        }, 100)
      } else {
        if (!row) {
          row = this.selectedJob || this.readSelectedRows()[0]
        }
        if (this.viewJobNoSet.has(row.jobNo)) {
          this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: row.jobNo }})
        } else {
          this.$emit('look', row)
        }
      }
    },
    // 新增
    addHandler() {
      this.$emit('add')
    },
    // 编辑
    async editHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      // 协作状态
      if (this.selectedJob.cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        if (this.selectedJob.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code) {
          const cooperateStatusStr = JobUtils.getStateName(this.selectedJob.cooperateStatus, SystemConstants.COOPERATE_STATUS)
          this.$message.warning(this.$t('Message.CanNotEditJob', [this.$t('CargoMsg.Cargo_CooperateStatus') + cooperateStatusStr]))
          return
        }
        this.$emit('edit', this.selectedJob)
        return
      }
      if (this.selectedJob.jobState > -1) {
        this.$message.warning(this.$t('Message.PromissoryNoteIsAFormalBusiness'))
        return
      }
      if (!await SecurityUtil.canEdit(new SeaImportJob(this.selectedJob), false)) {
        this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      const row = this.selectedJob
      if (this.viewJobNoSet.has(row.jobNo)) {
        this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: row.jobNo }, params: { action: 'edit' }})
        return
      }
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: row.jobNo }, params: { rowData: [...this.rowData], action: 'edit' }})
      } else {
        row.version = 0 // 以便于从数据库中加载Job数据
        this.$emit('edit', row)
      }
    },
    // 复制
    copyJobHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.selectedJob)
    },
    // 删除
    deleteHandler() {
      if (this.selectedDataList && this.selectedDataList.length > 1) {
        for (const item of this.selectedDataList) {
          if (this.isCooperate(item.cooperateStatus)) {
            this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
            return
          }
          if (this.viewJobNoSet.has(item.jobNo)) {
            this.$message.warning('[' + item.jobNo + ']' + this.$t('queryJob.JobOpenedAndCannotDelete'))
            return
          }
        }
        this.$emit('batchDelete', { jobList: this.selectedDataList, isInner: false })
      } else {
        if (this.selectedJob && this.isCooperate(this.selectedJob.cooperateStatus)) {
          this.$message.warning('[' + this.selectedJob.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (this.viewJobNoSet.has(this.selectedJob.jobNo)) {
          this.$message.warning('[' + this.selectedJob.jobNo + ']' + this.$t('queryJob.JobOpenedAndCannotDelete'))
          return
        }
        this.$emit('delete', { job: this.selectedJob, isInner: false })
      }
    },
    submitHanlder() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      const keys = []
      for (const row of this.selectedDataList) {
        if (this.isCooperate(row.cooperateStatus)) {
          this.$message.warning('[' + row.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (row.preverifyState === 3 || row.preverifyState === 4 || row.preverifyState === 6) {
          keys.push(row.uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.success(this.$t('Message.SuccessfullySubmittedXBusinessOtherIgnore', { num: 0 }))
        return
      }
      const loading = getLoading4Cxt(this)
      batchUpdatePreVerifyState(keys, 1).then(res => {
        for (const item of this.rowData) {
          for (const newJob of res.data) {
            if (item.uuid === newJob.uuid) {
              item.jobVersion = newJob.version
              item.preverifyState = newJob.preverifyState
              break
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
        if (keys.length === this.selectedDataList.length) {
          this.$message.success(this.$t('Message.SuccessfullySubmittedXBusiness', { num: keys.length }))
        } else {
          this.$message.success(this.$t('Message.SuccessfullySubmittedXBusinessOtherIgnore', { num: keys.length }))
        }
      }).finally(() => {
        loading.close()
      })
    },
    revokeHanlder() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      const keys = []
      for (const row of this.selectedDataList) {
        if (this.isCooperate(row.cooperateStatus)) {
          this.$message.warning('[' + row.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (row.preverifyState === 0 || row.preverifyState === 1) {
          keys.push(row.uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.success(this.$t('Message.SuccessfullyRevokedXBusinessOtherIgnore', { num: 0 }))
        return
      }
      const loading = getLoading4Cxt(this)
      batchUpdatePreVerifyState(keys, 4).then(res => {
        for (const item of this.rowData) {
          for (const newJob of res.data) {
            if (item.uuid === newJob.uuid) {
              item.jobVersion = newJob.version
              item.preverifyState = newJob.preverifyState
              break
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
        if (keys.length === this.selectedDataList.length) {
          this.$message.success(this.$t('Message.SuccessfullyRevokedXBusiness', { num: keys.length }))
        } else {
          this.$message.success(this.$t('Message.SuccessfullyRevokedXBusinessOtherIgnore', { num: keys.length }))
        }
      }).finally(() => {
        loading.close()
      })
    },
    clearSelect() {
      this.selectedJob = null
      this.selectedDataList = null
    },
    // 转正式业务
    convertToRealJobHandler() {
      if (this.forecastApproval) {
        if (!this.selectedDataList || this.selectedDataList.length === 0) {
          this.$message.warning(this.$t('Message.SelectJob'))
          return
        }
        for (const row of this.selectedDataList) {
          if (this.isCooperate(row.cooperateStatus)) {
            this.$message.warning('[' + row.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
            return
          }
        }
        this.$emit('regularBusiness', { job: null, jobs: this.selectedDataList, isInner: false })
      } else {
        if (!this.selectedJob && !this.selectedDataList) {
          this.$message.warning(this.$t('Message.SelectJob'))
          return
        }
        if (this.isCooperate(this.selectedJob.cooperateStatus)) {
          this.$message.warning('[' + this.selectedJob.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        this.$emit('regularBusiness', { job: this.selectedJob, jobs: this.selectedDataList, isInner: false })
      }
    },
    // 拒绝
    rejectHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.rejectWindow.jobNo = this.selectedJob.jobNo
      this.rejectWindow.rejectCallBack = this.isCooperate(this.selectedJob.cooperateStatus) ? this.rejectCooperateCallBackHandler : this.rejectCallBackHandler
      this.rejectWindow.visible = true
    },
    // 拒绝回调函数
    rejectCallBackHandler(remark) {
      this.loading = getLoading()
      preVerifyReject({ 'jobUuid': this.selectedJob.uuid, 'remarks': remark, 'jobVersion': this.selectedJob.jobVersion }).then(res => {
        this.loading.close()
        for (const item of this.rowData) {
          if (item.uuid === this.selectedJob.uuid) {
            item.jobVersion = res.data.version
            item.jobState = res.data.jobState
            item.preverifyState = res.data.preverifyState
            item.bookingRefuseNote = res.data.bookingRefuseNote
          }
        }
        this.$message.success(this.$t('SeaExport.RefuseSuccess'))
      }).finally(res => {
        this.loading.close()
      })
    },
    // 获取选中行
    readSelectedRows(tips = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new SeaImportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 是否协作状态
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        return true
      }
      return false
    },
    // 协作状态: 审核通过
    acceptHandler(type) {
      const jobLists = this.gridApi.getSelectedRows()
      if (!jobLists || jobLists.length <= 0) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (jobLists.length > 50) {
        this.$message.warning(this.$t('SeaExport.BatchAuditBusinessTip'))
        return
      }
      const cooperateList = []
      for (const seaJob of jobLists) {
        if (this.isCooperate(seaJob.cooperateStatus)) { cooperateList.push(seaJob.uuid) }
      }
      if (cooperateList.length > 0) {
        if (cooperateList.length !== jobLists.length) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateReviewSeparately'))
          return
        }
        this.acceptCooperateHandler(type, cooperateList)
        return
      }
    },
    acceptCooperateHandler(type, cooperateList) {
      if (!cooperateList || cooperateList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuids = cooperateList
      this.cooperationVerifyDialog.jobUuid = this.selectedJob.uuid // 显示其中一笔
      const cooperate = {
        branchId: this.selectedJob.cooperateBranchId,
        opId: this.selectedJob.cooperateOpId,
        csrId: this.selectedJob.cooperateCsrId,
        overseaOp: this.selectedJob.cooperateOverseaOp,
        dcId: this.selectedJob.cooperateDcId,
        planner: this.selectedJob.cooperatePlanner,
        sales: this.selectedJob.cooperateSales,
        cargoSalesId: this.selectedJob.cooperateCargoSalesId,
        userDefinedRoleId1: this.selectedJob.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.selectedJob.cooperateUserDefinedRoleId2,
        businessType: this.selectedJob.cooperateBusinessTypeCode ? this.selectedJob.cooperateBusinessTypeCode.split(',') : []
      }
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuids: this.cooperationVerifyDialog.jobUuids, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.selectedJob.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
#app #prediction-tree-grid {
}
</style>
